import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';
import SelectAlteracao from '../common/form/selectAlteracao';

import {
	setModoTela, initForm
} from './laudoOficinaActions';
import ButtonTable from '../common/table/buttonTable';

class LaudoOficinaForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome' placeholder='Informe o nome'
								cols='12 6 6 6'
								readOnly={readOnly} />
							
							<Field
								name='latitude'
								component={LabelAndInput}
								label='Latitude' placeholder='Informe a latitude'
								cols='3 3 3 3'
								readOnly={readOnly} />
							
							<Field
								name='longitude'
								component={LabelAndInput}
								label='Longitude' placeholder='Informe a longitude'
								cols='3 3 3 3'
								readOnly={readOnly} />
						</Row>

						{this.props.formularioValues.condicoes.map((condicao, i) => {


							return (
								<div key={condicao.id}>

									<Row alignCenter style={{ alignItems: 'center', marginBottom: 16 }}>
										<div style={{ flex: 1, height: 1, backgroundColor: '#ccc' }} />
										<label style={{ marginHorizontal: 8, paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0, paddingLeft: 4, paddingRight: 4 }}>
											{i > 0 ? 'Ou' : 'Condições'}
										</label>
										<div style={{ flex: 1, height: 1, backgroundColor: '#ccc' }} />
									</Row>

									{condicao.itens.map((item, j) => {

										return (
											<Row key={item.id} alignCenter>
												<label style={{ paddingTop: 8, width: 30 }}>{j == 0 ? 'Se' : 'e'}</label>
												<Select
													options={[
														{ id: 'raio', valor: 'Raio' },
														{ id: 'rumo', valor: 'Rumo' },
														{ id: 'fronteira', valor: 'Fronteira' },
														{ id: 'municipio', valor: 'Município' }
													]}
													label={null} 
													placeholder='Informe'
													cols='1 1 1 1'
													minWidth={200}
													readOnly={item.tipo ? 'readOnly' : readOnly}
													value={item.tipo}
													onChange={value => {
														this.props.initForm({
															...this.props.formularioValues,
															condicoes: this.props.formularioValues.condicoes.map(condicaoAux => {
																if (condicaoAux.id == condicao.id) {
																	return {
																		...condicao,
																		itens: condicao.itens.map(itemAux => {
																			if (item.id == itemAux.id) {
																				return {
																					...item,
																					tipo: value
																				};
																			} else {
																				return itemAux
																			}
																		})
																	};
																} else {
																	return condicaoAux;
																}

															})
														});
													}} />
												
												<Select
													options={[
														{ id: 'menor', valor: 'Menor', tipos: ['raio'] },
														{ id: 'maior', valor: 'Maior', tipos: ['raio'] },
														{ id: 'igual', valor: 'Igual', tipos: ['rumo', 'fronteira', 'municipio'] },
														{ id: 'diferente', valor: 'Diferente', tipos: ['rumo', 'fronteira', 'municipio'] }
													].filter(tipoCondicao => tipoCondicao.tipos.includes(item.tipo))}
													label={null} 
													placeholder='Informe'
													cols='1 1 1 1'
													minWidth={200}
													readOnly={readOnly}
													value={item.condicao}
													onChange={value => {
														this.props.initForm({
															...this.props.formularioValues,
															condicoes: this.props.formularioValues.condicoes.map(condicaoAux => {
																if (condicaoAux.id == condicao.id) {
																	return {
																		...condicao,
																		itens: condicao.itens.map(itemAux => {
																			if (item.id == itemAux.id) {
																				return {
																					...item,
																					condicao: value
																				};
																			} else {
																				return itemAux
																			}
																		})
																	};
																} else {
																	return condicaoAux;
																}

															})
														});
													}} />
													
												<Select
													options={
														item.tipo == 'raio' 
														? Array.from(new Array(50).keys()).map(km => ({ id: km * 10, valor: `${km * 10} km` }))
														: (
															item.tipo == 'rumo' 
															? [{ id: 'Nacional', valor : 'Nacional' }, { id: 'RN', valor : 'RN' }, { id: 'RS', valor : 'RS' }]
															: (
																item.tipo == 'fronteira'
																? this.props.listaFronteira.map(fronteira => ({ id: fronteira.fronteira, valor : fronteira.fronteira }))
																: (
																	item.tipo == 'municipio'
																	? this.props.listaCidade
																	: []
																)
															)
														)

													}
													label={null} 
													placeholder='Informe'
													cols='6 6 6 6'
													readOnly={readOnly}
													value={item.valor}
													multiple={item.tipo != 'raio'}
													onChange={value => {
														this.props.initForm({
															...this.props.formularioValues,
															condicoes: this.props.formularioValues.condicoes.map(condicaoAux => {
																if (condicaoAux.id == condicao.id) {
																	return {
																		...condicao,
																		itens: condicao.itens.map(itemAux => {
																			if (item.id == itemAux.id) {
																				return {
																					...item,
																					valor: item.tipo == 'raio' ? value : value.map(item => item.value)
																				};
																			} else {
																				return itemAux
																			}
																		})
																	};
																} else {
																	return condicaoAux;
																}

															})
														});
													}} />
												
												{!readOnly &&
												<div style={{ width: 100 }}>
													<ButtonTable
														type={'danger'}
														icon={'fas fa-trash-alt'}
														visible={true}
														height={38}
														event={() => {
															this.props.initForm({
																...this.props.formularioValues,
																condicoes: this.props.formularioValues.condicoes.map(condicaoAux => {
																	if (condicaoAux.id == condicao.id) {
																		return {
																			...condicao,
																			itens: condicao.itens.filter(itemAux => item.id != itemAux.id)
																		};
																	} else {
																		return condicaoAux;
																	}
																}).filter(condicao => condicao.itens.length)
															});
														}} />
													
													{j == condicao.itens.length -1 &&
													<ButtonTable
														type={'success'}
														icon={'fas fa-plus'}
														visible={true}
														height={38}
														event={() => {
															this.props.initForm({
																...this.props.formularioValues,
																condicoes: this.props.formularioValues.condicoes.map(condicaoAux => {
																	if (condicaoAux.id == condicao.id) {
																		let itens = condicao.itens.map(itemAux => itemAux);
																		itens.push({
																			id: new Date().getTime(),
																		});
																		return {
																			...condicao,
																			itens: itens
																		};
																	} else {
																		return condicaoAux;
																	}
																})
															});
														}} />}
												</div>}
											</Row>
										);
									})}
								</div>
							);
						})}

						{!readOnly &&
						<Row alignCenter>
							<div class='col-md-4' style={{ marginTop: 24, marginBottom: 24 }}>
								<button
									type='button'
									class='btn btn-primary btn-block'
									onClick={() => {
										let condicoes = this.props.formularioValues.condicoes.map(condicao => condicao);
										condicoes.push({
											id: new Date().getTime(),
											itens: [{
												id: new Date().getTime(),
											}]
										});
										this.props.initForm({
											...this.props.formularioValues,
											condicoes: condicoes
										});
									}}>
									<i class='fa fa-plus'></i> Adicionar Condição
								</button>
							</div>
						</Row>}
						
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }


}

LaudoOficinaForm = reduxForm({form: 'laudoOficinaForm', destroyOnUnmount: false})(LaudoOficinaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('laudoOficinaForm')(state),
	registro: state.laudoOficina.registro,
	listaFronteira: state.laudoOficina.listaFronteira,
	listaOperacao: state.laudoOficina.listaOperacao,
	listaCidade: state.laudoOficina.listaCidade
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LaudoOficinaForm);
